module.exports = "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title\">メモ</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n<input class=\"form-control\" maxlength=\"256\" [(ngModel)]=\"ret.yoyaku_memo\"/>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-dark\" (click)=\"modalCloseOK()\">OK</button>\r\n  <button type=\"button\" class=\"btn btn-dark\" (click)=\"modalCloseCancel()\">キャンセル</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0108-person/a-yoyaku-memo-modal.component.html
// module id = ./src/app/a0108-person/a-yoyaku-memo-modal.component.html
// module chunks = main